import { USStates } from 'utils/enums';

export const STATE_DROPDOWN_OPTIONS = USStates().map((state) => {
  return {
    label: state.label,
    value: state.id,
  };
});

export const MAX_FILE_SIZE_IN_BYTES = 5242880; // equivalent to 5 megabytes

export const MAX_FILE_NAME_CHARACTER_LENGTH = 215;

export const CONNECT_PROFILE_STATE_PREFERENCE_OPTIONS = [
  { label: 'Alabama', value: 1, isActive: false, isPreLaunch: false },
  { label: 'Alaska', value: 2, isActive: false, isPreLaunch: false },
  { label: 'Arizona', value: 3, isActive: false, isPreLaunch: false },
  { label: 'Arkansas', value: 4, isActive: true, isPreLaunch: true },
  { label: 'California', value: 5, isActive: false, isPreLaunch: false },
  { label: 'Colorado', value: 6, isActive: false, isPreLaunch: false },
  { label: 'Connecticut', value: 7, isActive: false, isPreLaunch: false },
  { label: 'Delaware', value: 8, isActive: false, isPreLaunch: false },
  { label: 'Florida', value: 9, isActive: false, isPreLaunch: false },
  { label: 'Georgia', value: 10, isActive: false, isPreLaunch: false },
  { label: 'Hawaii', value: 11, isActive: false, isPreLaunch: false },
  { label: 'Idaho', value: 12, isActive: false, isPreLaunch: false },
  { label: 'Illinois', value: 13, isActive: false, isPreLaunch: false },
  { label: 'Indiana', value: 14, isActive: true, isPreLaunch: true },
  { label: 'Iowa', value: 15, isActive: false, isPreLaunch: false },
  { label: 'Kansas', value: 16, isActive: false, isPreLaunch: false },
  { label: 'Kentucky', value: 17, isActive: false, isPreLaunch: false },
  { label: 'Louisiana', value: 18, isActive: false, isPreLaunch: false },
  { label: 'Maine', value: 19, isActive: false, isPreLaunch: false },
  { label: 'Maryland', value: 20, isActive: false, isPreLaunch: false },
  { label: 'Massachusetts', value: 21, isActive: false, isPreLaunch: false },
  { label: 'Michigan', value: 22, isActive: false, isPreLaunch: false },
  { label: 'Minnesota', value: 23, isActive: false, isPreLaunch: false },
  { label: 'Mississippi', value: 24, isActive: false, isPreLaunch: false },
  { label: 'Missouri', value: 25, isActive: true, isPreLaunch: false },
  { label: 'Montana', value: 26, isActive: false, isPreLaunch: false },
  { label: 'Nebraska', value: 27, isActive: false, isPreLaunch: false },
  { label: 'Nevada', value: 28, isActive: false, isPreLaunch: false },
  { label: 'New Hampshire', value: 29, isActive: false, isPreLaunch: false },
  { label: 'New Jersey', value: 30, isActive: false, isPreLaunch: false },
  { label: 'New Mexico', value: 31, isActive: false, isPreLaunch: false },
  { label: 'New York', value: 32, isActive: false, isPreLaunch: false },
  { label: 'North Carolina', value: 33, isActive: false, isPreLaunch: false },
  { label: 'North Dakota', value: 34, isActive: false, isPreLaunch: false },
  { label: 'Ohio', value: 35, isActive: false, isPreLaunch: false },
  { label: 'Oklahoma', value: 36, isActive: true, isPreLaunch: true },
  { label: 'Oregon', value: 37, isActive: false, isPreLaunch: false },
  { label: 'Pennsylvania', value: 38, isActive: false, isPreLaunch: false },
  { label: 'Rhode Island', value: 39, isActive: false, isPreLaunch: false },
  { label: 'South Carolina', value: 40, isActive: false, isPreLaunch: false },
  { label: 'South Dakota', value: 41, isActive: false, isPreLaunch: false },
  { label: 'Tennessee', value: 42, isActive: true, isPreLaunch: false },
  { label: 'Texas', value: 43, isActive: false, isPreLaunch: false },
  { label: 'Utah', value: 44, isActive: false, isPreLaunch: false },
  { label: 'Vermont', value: 45, isActive: false, isPreLaunch: false },
  { label: 'Virginia', value: 46, isActive: false, isPreLaunch: false },
  { label: 'Washington', value: 47, isActive: false, isPreLaunch: false },
  { label: 'West Virginia', value: 48, isActive: false, isPreLaunch: false },
  { label: 'Wisconsin', value: 49, isActive: false, isPreLaunch: false },
  { label: 'Wyoming', value: 50, isActive: false, isPreLaunch: false },
  { label: 'Guam', value: 51, isActive: false, isPreLaunch: false },
  { label: 'Puerto Rico', value: 52, isActive: false, isPreLaunch: false },
  { label: 'Virgin Islands', value: 53, isActive: false, isPreLaunch: false },
  { label: 'District of Columbia', value: 54, isActive: false, isPreLaunch: false },
];

export const SHOULD_SHOW_EXPRESS_INTEREST_WAITLIST_BUTTON = true;
